import React from 'react'
import { useAudio } from '../../context/AudioContext'

function formatTime(seconds) {
    if (!seconds || Number.isNaN(seconds)) return '0:00'

    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0')

    return `${mins}:${secs}`
}

export default function BottomPlayer() {
    const {
        currentTrack,
        isPlaying,
        currentTime,
        duration,
        togglePlayPause,
        seekTo,
    } = useAudio()

    return (
        <div className={`bottom-player ${currentTrack ? 'is-visible' : ''}`}>
            <div className="bottom-player__meta">
                <div className="bottom-player__title">
                    {currentTrack?.title || 'The stage is quiet'}
                </div>
                <div className="bottom-player__time">
                    {formatTime(currentTime)} / {formatTime(duration)}
                </div>
            </div>

            <div className="bottom-player__controls">
                <button
                    className="bottom-player__button"
                    onClick={togglePlayPause}
                    type="button"
                >
                    {isPlaying ? 'Pause' : 'Play'}
                </button>
            </div>

            <div className="bottom-player__progress">
                <input
                    type="range"
                    min="0"
                    max={duration || 0}
                    value={Math.min(currentTime, duration || 0)}
                    onChange={(e) => seekTo(Number(e.target.value))}
                />
            </div>
        </div>
    )
}